var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 16,
    viewBox: "0 0 18.999 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-mark-inside-a-circle",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c129_exclamation",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34859",
    "data-name": "Path 34859",
    d: "M9.5,0A9.5,9.5,0,1,0,19,9.5,9.5,9.5,0,0,0,9.5,0Zm0,18.027A8.528,8.528,0,1,1,18.028,9.5,8.527,8.527,0,0,1,9.5,18.027Z",
    transform: "translate(-0.001)",
    fill: "#c40101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34860",
    "data-name": "Path 34860",
    d: "M14.369,13.126l.416-8.547H11.8l.414,8.547Z",
    transform: "translate(-3.784 -1.468)",
    fill: "#c40101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34861",
    "data-name": "Path 34861",
    d: "M13.2,18.546a1.718,1.718,0,0,0-.038,3.434H13.2a1.717,1.717,0,0,0,0-3.434Z",
    transform: "translate(-3.686 -5.945)",
    fill: "#c40101"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.3ca00496.svg";
export { ForwardRef as ReactComponent };